import React from 'react';
import { isEmpty } from '@/utils/common-helpers';

type Props = {
    desc?: any;
    pageTitle: string;
    bg: string;
    ndaText?: string;
    discussingRequirementText?: string;
    designingText?: string;
    developmentText?: string;
    deploymentText?: string;
    supportAndMaintenanceText?: string;
};

const HireProcessAimlDev: React.FC<Props> = ({
    pageTitle,
    desc,
    bg,
    ndaText,
    designingText,
    developmentText,
    deploymentText,
    supportAndMaintenanceText,
    discussingRequirementText,
}) => {
    return (
        <section className={`section-py !pb-0 ${bg}`}>
            <div className="text-white container lg:container mx-auto">
                <div className="row grid md:grid-cols-12 !gap-y-0">
                    <div className="md:col-span-8 md:col-start-3 mb-5 md:mb-[70px] lg:mb-0">
                        <div className="flex flex-col gap-2.5 text-center">
                            <h2 className="text-white">{pageTitle}</h2>
                            <p className="text-grey mb-0 fw-600 dark:text-[#D7DEE5]">{desc}</p>
                        </div>
                    </div>
                    <div className="md:col-span-12 xl:col-span-12 xxl:col-span10 text-center about-us-animation">
                        <div className="process-list process-list-about">
                            <div className="process-item process-item-white text-center">
                                <div className="process-icon process-icon-white mx-auto mb-4 grid rounded-full">
                                    <svg>
                                        <use xlinkHref="#ic-signin-nda" />
                                    </svg>
                                </div>
                                <p className="text-white fw-500 px-2.5 mb-[15px] custom-min-height">
                                    Discovery & Initial Planning
                                </p>
                                <p className="text-grey fs-md fw-400 mb-0 px-3 minheight-cardinner-pag">
                                    {isEmpty(ndaText)
                                        ? 'We begin by understanding your requirements and goals, ensuring a tailored approach.'
                                        : ndaText}
                                </p>
                            </div>
                            <div className="circle circle-white circle-reverse" />
                            <div className="process-item  process-item-white process-item-reverse text-center">
                                <div className="process-icon process-icon-white process-icon-reverse mx-auto mb-4 grid rounded-full">
                                    <svg>
                                        <use xlinkHref="#ic-discussing" />
                                    </svg>
                                </div>
                                <p className="text-white fw-500 px-2.5 mb-[15px] custom-min-height">Data Gathering & Cleaning</p>
                                <p className="text-grey fs-md fw-400 mb-0 px-3 minheight-cardinner-pag">
                                    {isEmpty(discussingRequirementText)
                                        ? 'We collect and preprocess data to ensure accuracy and quality for model development.'
                                        : discussingRequirementText}
                                </p>
                            </div>
                            <div className="circle circle-white circle-2" />
                            <div className="process-item process-item-white text-center">
                                <div className="process-icon process-icon-white mx-auto mb-4 grid rounded-full">
                                    <svg>
                                        <use xlinkHref="#ic-designing" />
                                    </svg>
                                </div>
                                <p className="text-white fw-500 px-2.5 mb-[15px] custom-min-height">
                                    Model Development and/or Training
                                </p>
                                <p className="text-grey fs-md fw-400 mb-0 px-3 minheight-cardinner-pag">
                                    {isEmpty(designingText)
                                        ? 'Our AI/ML experts build scalable, high-performing models using advanced algorithms.'
                                        : designingText}
                                </p>
                            </div>
                            <div className="circle circle-white circle-reverse circle-3" />
                            <div className="process-item process-item-white process-item-reverse text-center">
                                <div className="process-icon process-icon-white mx-auto mb-4 grid rounded-full">
                                    <svg>
                                        <use xlinkHref="#ic-development" />
                                    </svg>
                                </div>
                                <p className="text-white fw-500 px-2.5 mb-[15px] custom-min-height">Testing & Validation</p>
                                <p className="text-grey fs-md fw-400 mb-0 px-3 minheight-cardinner-pag">
                                    {isEmpty(developmentText)
                                        ? 'We rigorously test models using real-world data to ensure they meet your objectives.'
                                        : developmentText}
                                </p>
                            </div>
                            <div className="circle circle-white circle-4" />
                            <div className="process-item process-item-white text-center">
                                <div className="process-icon process-icon-white mx-auto mb-4 grid rounded-full">
                                    <svg>
                                        <use xlinkHref="#ic-deployment" />
                                    </svg>
                                </div>
                                <p className="text-white fw-500 px-2.5 mb-[15px] custom-min-height">Deployment</p>
                                <p className="text-grey fs-md fw-400 mb-0 px-3 minheight-cardinner-pag">
                                    {isEmpty(deploymentText)
                                        ? 'Our team implements the solution in a live environment, ensuring seamless integration.'
                                        : deploymentText}
                                </p>
                            </div>
                            <div className="circle circle-white circle-reverse circle-5" />
                            <div className="process-item process-item-white process-item-reverse text-center">
                                <div className="process-icon process-icon-white mx-auto mb-4 grid rounded-full">
                                    <svg>
                                        <use xlinkHref="#ic-support" />
                                    </svg>
                                </div>
                                <p className="text-white fw-500 px-2.5 mb-[15px] custom-min-height">Maintenance & Support</p>
                                <p className="text-grey fs-md fw-400 mb-0 px-3 minheight-cardinner-pag">
                                    {isEmpty(supportAndMaintenanceText)
                                        ? 'We offer ongoing support and maintenance to optimize and update your AI/ML solutions over time.'
                                        : supportAndMaintenanceText}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HireProcessAimlDev;
